var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5282 3.75549V0L12.6604 1.77026C12.165 2.23992 11.8867 2.87676 11.8867 3.5407V3.75549L12.4663 7.60088C12.5178 7.94292 12.4178 8.29008 12.1901 8.55998L10.7668 10.2052L1.32074 1.25189L0 2.50378L9.57649 11.5808L1.39883 21.0326C0.978514 21.5306 1.02035 22.2486 1.49624 22.6997L2.26986 23.4329C2.82247 23.9566 3.73122 23.9137 4.22597 23.3404L11.7069 14.8518L13.2075 16.274V16.489C13.2075 17.1529 13.4857 17.7898 13.9812 18.2592L19.2641 23.2668C20.2956 24.2444 21.9681 24.2444 22.9996 23.2668L23.2263 23.0518C24.2579 22.0742 24.2579 20.4889 23.2263 19.5111L17.5565 14.137C17.3087 13.9023 16.9728 13.7704 16.6226 13.7704H15.8489L14.1114 12.1236L15.9295 10.0605C16.3023 9.62858 16.836 9.34459 17.4189 9.26567C19.6746 8.96025 21.551 7.43883 22.2057 5.37011C22.7539 3.63812 22.1373 1.76385 20.6475 0.634093L19.8111 0V3.75549L17.1697 5.00738L14.5282 3.75549Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/Tools.0013937feac3f16d4584be561ddea650.svg";
export { ForwardRef as ReactComponent };